<template>
  <validation-observer
    ref="saveFormRef"
  >
    <b-modal
      id="viewDossierResultFileModal"
      body-class="position-static"
      centered
      modal-class="custom-modal-size"
      title="Danh sách file kết quả"
      :no-close-on-backdrop="true"
      no-close-on-esc
      @show="onShow"
      @hide="onHide"
    >
      <b-form>
        <b-row>
          <b-col cols="12">
            <vue-good-table
              mode="remote"
              class="my-table"
              :columns="columns"
              :rows="uploadedFiles"
              :total-rows="uploadedFiles.length"
              line-numbers
            >
              <template
                slot="table-row"
                slot-scope="props"
              >
                <span v-if="props.column.field === 'files'">
                  <template v-for="(file, index) in props.row.files">
                    <feather-icon icon="FileIcon" />
                    <span
                      class="uploaded-file-name"
                      :title="'Bấm vào để tải về ' + file.name"
                      @click="onDownload(file.objectPath)"
                    >
                      {{ file.name }}
                    </span>
                    <br v-if="index !== props.row.files.length - 1">
                  </template>
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide('viewDossierResultFileModal')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Đóng
            </span>
          </b-button>
        </div>
      </template>
      <b-overlay
        no-wrap
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="isLoading"
      />
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BButton,
  BCol,
  BForm,
  BModal,
  BOverlay,
  BRow,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { VueGoodTable } from 'vue-good-table'
import { ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import { TemplateFileStatus } from '@/const/dossier-status'
import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'

export default {
  name: 'FormActionTemplate',
  directives: {
    Ripple,
  },
  components: {
    BOverlay,
    BModal,
    ValidationObserver,
    BForm,
    BButton,
    BRow,
    BCol,
    VueGoodTable,
  },
  props: {
    item: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      isLoading: false,
      mediaIds: [],
      uploadedFiles: [],
      nameFile: null,
      placeholder: 'Chọn file để tải tài liệu...',
      required,
      targetItem: {},
    }
  },
  computed: {
    columns() {
      return [
        {
          label: 'Tên bước',
          field: 'stepName',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Tên cán bộ xử lý',
          field: 'employeeName',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'File kết quả',
          field: 'files',
          sortable: false,
          thClass: 'text-center',
        },
      ]
    },
  },
  mounted() {
    const style = document.createElement('style')
    style.innerHTML = `
      .custom-modal-size .modal-dialog {
        max-width: 70% !important;
        margin: auto !important;
      }
    `
    document.head.appendChild(style)
    this.customStyleElement = style
  },
  methods: {
    // eslint-disable-next-line consistent-return
    async fetchAllResultFileByDossierId(dossierId) {
      try {
        const response = await axios.get(`oneGate/dossierResultFiles/getAllByDossierId/${dossierId}`)
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          return data.data
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async onShow() {
      this.$refs.saveFormRef.reset()
      this.targetItem = {}
      this.uploadedFiles = []
      this.targetItem = this.item ? { ...this.item } : {}
      if (this.targetItem.mediaIds === undefined) {
        this.targetItem.mediaIds = []
      }
      await this.getAllResultFileByDossierId(this.targetItem.id)
    },
    onHide() {
      this.$refs
        .saveFormRef
        .reset()
    },
    async getAllResultFileByDossierId(dossierId) {
      if (dossierId) {
        await this.fetchAllResultFileByDossierId(dossierId).then(response => {
          const groupedFiles = response.reduce((acc, file) => {
            if (!acc[file.stepId]) {
              acc[file.stepId] = {
                stepName: file.stepName,
                employeeName: file.employeeName,
                files: [],
              }
            }
            acc[file.stepId].files.push({
              name: file.name,
              objectPath: file.objectPath,
            })

            return acc
          }, {})
          this.uploadedFiles = Object.values(groupedFiles)
        })
      }
    },
    // eslint-disable-next-line consistent-return
    async downloadTemplate(params) {
      try {
        const response = await axios.get('oneGate/template-files/download', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          return data.data
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async onDownload(objectPath) {
      this.isLoading = true
      try {
        const type = TemplateFileStatus.TEMPLATE_ATTACHMENT_DOSSIER
        this.url = await this.downloadTemplate({ objectPath, type })
        if (this.url) {
          window.open(this.url, '_blank')
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    showToast(title, icon, variant) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title,
          icon,
          variant,
        },
      })
    },
  },
}
</script>

<style scoped>
.uploaded-file-name {
  font-size: 1rem;
  font-weight: 500;
}

.uploaded-file-name {
  cursor: pointer;
  color: blue;
}

.uploaded-file-name:hover {
  text-decoration: underline;
}
</style>
